﻿export class inductryMaster {
    inductryId: string;
    inductryName: string;
    isActive: string;
    displayOrder: string;
    totalRecords:string;
    encryInductryId:string;
    hazardMasterId:string;
    hazardName:string;
}